import {useMediaQuery} from "react-responsive";

const AboutDetail = ({flip=true, about, change}) => {
    const isDesktop = useMediaQuery({ minWidth: 992 });
    return (
        <div className={""+(change?"h-about-container":"")} id={about.link}>
            <div className={"separator"}></div>
            {
                !isDesktop || flip ?
                    <div className={"row "}>
                        <div className={"col-md-8"}>
                            <h2 className={"mini-title animate"}>{about.title}</h2>
                            <p className={"description animate"}>
                                {about.description}
                            </p>
                        </div>
                        <div className={"col-md-4"}>
                            <div className={"h-img animate"}>
                                <img src={about.photo} alt={"agri-tech solution madagascar"}/>

                            </div>
                        </div>
                    </div>:
                    <div className={"row"}>
                        <div className={"col-md-4"}>
                            <div className={"h-img animate"}>
                                <img src={about.photo} alt={"agri-tech solution madagascar"}/>

                            </div>
                        </div>
                        <div className={"col-md-8"}>
                            <h2 className={"mini-title animate"}>{about.title}</h2>
                            <p className={"description animate"}>
                                {about.description}
                            </p>
                        </div>
                    </div>
            }
            <div className={"separator"}></div>


        </div>
    )
}

export default AboutDetail;